class OjaBrandValues extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[role="tabpanel"]');
      const index = this.panels.indexOf(panel);
      if (index >= 0) this.select(index);
    });
  }

  select(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', selected.toString());
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();

    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    this.select(nextIndex, true);
  }
}

if (!customElements.get('oja-brand-values')) {
  customElements.define('oja-brand-values', OjaBrandValues);
}
